import { Toast } from 'vant'
import handleCopy from '@/utils/copy.js'
import { inviteCodeKey } from '@/common/http'
import { verifyToken } from '@/api/user'
import store from '@/store'
import { setPn } from '@/utils/pn'
export default {
    data() {
        return {
            nationObj: {
                Mexico: {
                    img: require('@/assets/lang/Mexico.jpeg')
                },
                Peru: {
                    img: require('@/assets/lang/Peru.jpg')
                }
            },
            langObj: {
                en_US: {
                    type: 'en_US',
                    name: 'English',
                    img: require('@/assets/lang/usa.png')
                },
                pt_BR: {
                    type: 'pt_BR',
                    name: 'Português',
                    img: require('@/assets/lang/brazil.png')
                },
                es_MX: {
                    type: 'es_MX',
                    name: 'Español',
                    img: require('@/assets/lang/Mexico.jpeg')
                },
                es_PE: {
                    type: 'es_PE',
                    name: 'Español',
                    img: require('@/assets/lang/Peru.jpg')
                },
                ur_PK: {
                    type: 'ur_PK',
                    name: 'پاکستان',
                    img: require('@/assets/lang/pakistan.png')
                },
                ru_RU: {
                    type: 'ru_RU',
                    name: 'Russia',
                    img: require('@/assets/lang/Russia.webp')
                }
            },
            CurrencyTypeObj: {
                Brazil: 'R$',
                Pakistan: 'Rs',
                Nigeria: '₦',
                India: '₹',
                Peru: 'S/',
                Russia: '₽‌',
                USA: '$',
                Mexico: '$'
            },
            timeZoneObj: {
                Brazil: -3,
                Pakistan: 5,
                Nigeria: 1,
                India: 5.5,
                Peru: -5,
                Russia: 3,
                USA: -5,
                Mexico: -6
            }
        }
    },
    computed: {
        CurrencyType() {
            let Currency = ''
            const nation = store.getters.sysConfig?.nation
            if (nation) Currency = this.CurrencyTypeObj[nation]
            return Currency
        },
        BelongNation() {
            const nation = store.getters.sysConfig?.nation
            return nation
        },
        DisabledBelongCountry() {
            const isDisabled = store.getters.sysConfig?.disabledBelongCountry
            return isDisabled
        },
        isDownAppCanPlayGame() {
            const isDisabled = store.getters.sysConfig?.isDownAppCanPlayGame
            return isDisabled
        },
        allBalance() {
            const userInfo = this.$store.getters.userInfo
            let val
            if (userInfo) {
                let balanceAmt = 0
                let lockAmt = 0
                if (userInfo.balanceAmtAccount) balanceAmt = userInfo.balanceAmtAccount.useBalance
                if (userInfo.lockAmtAccount) lockAmt = userInfo.lockAmtAccount.useBalance
                const total = Number(balanceAmt) + Number(lockAmt)
                val = this.formatAmount(total, 2)
            }
            return val
        }
    },
    created() {
        // const that = this
        const opt = this.$route?.query
        const pathAct = this.$route?.name
        if (opt && opt.pn) {
            setPn(opt.pn)
        }
        if (opt && opt.token && pathAct !== 'depositWv') {
            store.commit('user/SET_TOKEN', '')
            this.$forceUpdate()
            store.commit('user/SET_TOKEN', opt.token)
        }
        if (opt && opt.ta) {
            store.dispatch('system/setPixel', opt.ta)
        }
        if (opt && opt.taid) {
            store.dispatch('system/setTaId', opt.taid)
            if (opt.ta && opt.ta === 'FaceBookPixel') {
                fbq('init', opt.taid) // eslint-disable-line
                fbq('set', 'mobileBridge', opt.taid, '') // eslint-disable-line
                fbq('track', 'PageView') // eslint-disable-line
                const noscript = document.createElement('noscript')
                const img = document.createElement('img')
                img.setAttribute('height', '1')
                img.setAttribute('width', '1')
                img.setAttribute('style', 'display:none')
                img.setAttribute('src', `https://www.facebook.com/tr?id=${opt.taid}&ev=PageView&noscript=1`)
                noscript.appendChild(img)
                document.head.appendChild(noscript)
                console.log('调用了fbq初始化init api,facebookId为', opt.taid)
            }
            if (opt && opt.ta && opt.ta === 'Kwai') {
                kwaiq.load(opt.taid) // eslint-disable-line
                kwaiq.page() // eslint-disable-line
            }
        }
        if (opt && opt.click_id) {
            store.dispatch('system/setClickId', opt.click_id)
        }
        if (opt && opt[inviteCodeKey]) {
            const invitCodeNum = store.getters.invitCodeNum
            if (invitCodeNum !== 2) store.dispatch('user/setInvitCodeNum', 1)
            store.dispatch('user/setInvitCode', opt[inviteCodeKey])
        } else {
            const url = decodeURIComponent(window.location.href)
            const sceneObj = {}
            url.split('#')[0].replace('?', '&').split('&').filter(item => {
                const key = item.split('=')
                sceneObj[key[0]] = key[1]
            })
            // console.log(scene)
            if (sceneObj[inviteCodeKey]) {
                const invitCodeNum = store.getters.invitCodeNum
                if (invitCodeNum !== 2) store.dispatch('user/setInvitCodeNum', 1)
                store.dispatch('user/setInvitCode', sceneObj[inviteCodeKey])
            } else if (url.indexOf(inviteCodeKey + '=') !== -1) {
                let code = url.split(inviteCodeKey + '=')[1]
                code = code.slice(0, 6)
                const invitCodeNum = store.getters.invitCodeNum
                if (invitCodeNum !== 2) store.dispatch('user/setInvitCodeNum', 1)
                store.dispatch('user/setInvitCode', code)
            }
            if (sceneObj.ta) {
                store.dispatch('system/setPixel', sceneObj.ta)
            }
            if (sceneObj.taid) {
                store.dispatch('system/setTaId', sceneObj.taid)
                if (sceneObj.ta && sceneObj.ta === 'FaceBookPixel') {
                    fbq('init', sceneObj.taid) // eslint-disable-line
                    fbq('set', 'mobileBridge', sceneObj.taid, '') // eslint-disable-line
                    fbq('track', 'PageView') // eslint-disable-line
                    const noscript = document.createElement('noscript')
                    const img = document.createElement('img')
                    img.setAttribute('height', '1')
                    img.setAttribute('width', '1')
                    img.setAttribute('style', 'display:none')
                    img.setAttribute('src', `https://www.facebook.com/tr?id=${sceneObj.taid}&ev=PageView&noscript=1`)
                    noscript.appendChild(img)
                    document.head.appendChild(noscript)
                    console.log('调用了fbq初始化init api,facebookId为', sceneObj.taid)
                }
                if (sceneObj.ta && sceneObj.ta === 'Kwai') {
                    kwaiq.load(sceneObj.taid) // eslint-disable-line
                    kwaiq.page() // eslint-disable-line
                }
            }
            if (sceneObj.click_id) {
                store.dispatch('system/setClickId', sceneObj.click_id)
            }
        }
        if (store?.getters.invitCode && (!store?.getters.token) && store?.getters.invitCodeNum === 1) {
            store.dispatch('user/setInvitCodeNum', 2)
            store.dispatch('user/changeLoginType', 1)
            store.dispatch('user/setIsShowLoginPopup', true)
        }
    },
    methods: {
        formatAmount(value, digits) {
            if (value === null || value === undefined || value === '') return value
            const raw = String(value).replace(/,/g, '').trim()
            const num = Number(raw)
            if (Number.isNaN(num)) return value

            let minimumFractionDigits = 0
            let maximumFractionDigits = 0

            if (typeof digits === 'number') {
                minimumFractionDigits = digits
                maximumFractionDigits = digits
            } else if (raw.includes('.')) {
                const decimalPart = raw.split('.')[1] || ''
                minimumFractionDigits = decimalPart.length
                maximumFractionDigits = decimalPart.length
            }

            return num.toLocaleString('en-US', {
                minimumFractionDigits,
                maximumFractionDigits
            })
        },
        formatCurrency(value, digits, withSpace = true) {
            const amount = this.formatAmount(value, digits)
            if (amount === null || amount === undefined || amount === '') return amount
            return `${this.CurrencyType}${withSpace ? ' ' : ''}${amount}`
        },
        onPageRefresh() {
            if (this.$route.path.indexOf('/Home') !== -1) {
                const opt = this.$route?.query
                if (opt && opt.token) {
                    console.log('token已经过期')
                    this.$router.replace({ path: '/' })
                }
                window.location.reload()
            } else {
                this.$router.replace({ path: '/' })
            }
        },
        /**
        * url
        * type 跳转类型 href get post
        * replace 是否去掉历史记录
        */
        onNavTo({ url, type, params, replace }) {
            // if (this.$route.path.indexOf(url) !== -1) {
            //     return
            // }
            const opt = params || {}
            if (type === 'href') {
                window.open(url)
            } else if (type === 'get') {
                // 会把要传递的参数显示在导航栏中
                // 新页面取参(刷新页面参数不会丢失)：this.$route.query.id
                this.$router.push({ path: url, query: opt })
            } else if (type === 'post') {
                // 默认不会把传递的参数显示在导航栏中
                // 新页面取参(刷新页面参数会丢失)：this.$route.params.id
                // 不想丢失可以在路由地址上添加预置位：
                // router配置
                // const routes = [{
                //     path: '/list/:id',
                //     name: 'list',
                //     component: List
                // }]
                this.$router.push({ name: url, params: opt })
            } else {
                if (replace === 1) {
                    this.$router.replace({ path: url })
                } else {
                    this.$router.push({ path: url, query: opt })
                }
            }
        },
        goBack() {
            this.$router.back()
            // const historyLength = this.$router.history.length
            // if (historyLength) {
            //     this.$router.back()
            // } else {
            //     if (this.$route.path.indexOf('/Home') !== -1) {
            //         window.location.reload()
            //     } else {
            //         this.onNavTo({ url: '/Home', replace: 1 })
            //     }
            // }
        },
        onNavToByIsLogin({ url, type, params, replace }) {
            return new Promise((resolve, reject) => {
                verifyToken().then((res) => {
                    if (res.code === 0) {
                        if (url) this.onNavTo({ url, type, params, replace })
                        resolve(true)
                    }
                }).catch((err) => {
                    reject(err)
                })
            })
        },
        // 复制
        onCopy(v) {
            if (!v) return
            handleCopy({
                content: v,
                success: (res) => {
                    Toast(res)
                },
                error: (e) => {
                    Toast(e)
                }
            }, this)
        },
        getLocalTime() {
            const nation = store.getters.sysConfig?.nation
            let i = 8
            if (nation) i = this.timeZoneObj[nation]
            if (typeof i !== 'number') return
            const d = new Date()
            const len = d.getTime()
            const offset = d.getTimezoneOffset() * 60000
            const utcTime = len + offset
            return utcTime + 3600000 * i
        },
        getNextDayTimestamp(timeStr) {
            const nation = store.getters.sysConfig?.nation
            let i = 8
            console.log(nation)
            if (nation) i = this.timeZoneObj[nation]
            console.log(i)
            if (typeof i !== 'number') return
            if (!timeStr) return 0
            // 1. 分割时分秒
            const [hours, minutes, seconds] = timeStr.split(':').map(Number)
            // 2. 创建当前时间对象
            const now = new Date()
            const len = now.getTime()
            const offset = now.getTimezoneOffset() * 60000
            const utcTime = len + offset
            const otherNow = new Date(utcTime + 3600000 * i)
            // 3. 设置为第二天
            otherNow.setDate(now.getDate() + 1)
            // 4. 精准设置时分秒毫秒
            otherNow.setHours(hours, minutes, seconds, 0)
            return otherNow.getTime()
        },
        getNextMondayTimestamp(timeStr) {
            const nation = store.getters.sysConfig?.nation
            let i = 8
            if (nation) i = this.timeZoneObj[nation]
            if (typeof i !== 'number') return
            if (!timeStr) return 0
            // 1. 拆分时分秒
            const [hours, minutes, seconds] = timeStr.split(':').map(Number)

            // 2. 获取当前日期
            const now = new Date()
            const today = now.getDay() // 周日0, 周一1, 周二2...周六6

            // 3. 计算距离下周一的天数（核心逻辑）
            let addDays
            if (today === 0) {
                addDays = 1 // 今天周日 → 明天就是下周一
            } else {
                addDays = 8 - today // 周一(1)加7天，周二(2)加6天...周六(6)加2天
            }
            const len = now.getTime()
            const offset = now.getTimezoneOffset() * 60000
            const utcTime = len + offset
            const otherNow = new Date(utcTime + 3600000 * i)
            // 4. 设置为下周一
            otherNow.setDate(now.getDate() + addDays)
            // 5. 设置目标时间（时分秒）
            otherNow.setHours(hours, minutes, seconds, 0)
            return otherNow.getTime()
        },
        getYmd() {
            const d = new Date()
            const y = d.getFullYear()
            const m = String(d.getMonth() + 1).padStart(2, '0')
            const d_ = String(d.getDate()).padStart(2, '0')
            return `${y}-${m}-${d_}`
        },
        formatDate(date) {
            const y = date.getFullYear()
            const m = String(date.getMonth() + 1).padStart(2, '0')
            const d = String(date.getDate()).padStart(2, '0')
            return `${y}-${m}-${d}`
        }
    }
}
